import { Component, output, input } from '@angular/core';

import type { User } from '@core/account-types';
import { TranslatePipe } from '@core/i18n-legacy';
import type { RequisitionFlow } from '@core/requisitions-types';
import {
  BadgeComponent,
  BoxComponent,
  ButtonComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DividerComponent,
  HeadingComponent,
  IconComponent,
} from '@core/user-interface-legacy';

import { RequisitionsFlowStepsListContainerComponent } from '../../../containers/single-requisition/requisitions-flow-steps-list-container/requisitions-flow-steps-list-container.component';
import { FlowStepViewContext } from '../../../requisitions.types';

@Component({
  selector: 'rt-requisitions-approval-request-flow-preview',
  templateUrl: './approval-request-flow-preview.component.html',
  styleUrls: ['./approval-request-flow-preview.component.less'],
  imports: [
    BadgeComponent,
    BoxComponent,
    ButtonComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    DividerComponent,
    HeadingComponent,
    IconComponent,
    RequisitionsFlowStepsListContainerComponent,
    TranslatePipe,
  ],
})
export class ApprovalRequestFlowPreviewComponent {
  public readonly flowViewContext = FlowStepViewContext.Dialog;

  public readonly flow = input<RequisitionFlow>(undefined!);
  public readonly adminsMap = input<Record<number, User>>(undefined!);
  public readonly departmentName = input<string>();
  public readonly isDepartmentsMode = input<boolean>(undefined!);

  public continue = output<void>();
  public cancel = output<void>();
}
